import { render, staticRenderFns } from "./BaseAdvButton.vue?vue&type=template&id=1cb47ce2&scoped=true&lang=pug&"
import script from "./BaseAdvButton.vue?vue&type=script&lang=js&"
export * from "./BaseAdvButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseAdvButton.vue?vue&type=style&index=0&id=1cb47ce2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb47ce2",
  null
  
)

export default component.exports